import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Property } from "../../../model/property";
import { BillingAdress } from "../../../model/billingAdress";
import { Country } from "../../../model/country";
import { CountryService } from "../../../service/country.service";

@Component({
  selector: 'app-billing-address-dialog',
  templateUrl: './billing-address-dialog.component.html',
  styleUrls: ['./billing-address-dialog.component.css']
})
export class BillingAddressDialogComponent implements OnInit {
  billingForm: UntypedFormGroup;
  beneficiaryForm: UntypedFormGroup;
  clickedButton = false;
  showBeneficiary: boolean = true;
  countries: Array<Country> = [];

  constructor(public dialogRef: MatDialogRef<BillingAddressDialogComponent>,
              private formBuilder: UntypedFormBuilder,
              private countryService: CountryService,
              @Inject(MAT_DIALOG_DATA) public data: {property: Property}) { }

    ngOnInit(): void {
        this.countries = this.countryService.getCountries();

        let billingName;
        let billingFirma;
        let billingStreet;
        let billingPlz;
        let billingTown;
        let billingCountry;

        if (this.data.property.billingAdress) {
            billingName = this.data.property.billingAdress.name ? this.data.property.billingAdress.name : '';
            billingFirma = this.data.property.billingAdress.firma ? this.data.property.billingAdress.firma : '';
            billingStreet = this.data.property.billingAdress.street ? this.data.property.billingAdress.street : '';
            billingPlz = this.data.property.billingAdress.plz ? this.data.property.billingAdress.plz : '';
            billingTown = this.data.property.billingAdress.town ? this.data.property.billingAdress.town : '';
            billingCountry = this.data.property.billingAdress.country ? this.data.property.billingAdress.country : '';
        }

        this.billingForm = this.formBuilder.group({
            name: new UntypedFormControl(billingName, Validators.maxLength(440)),
            firma: new UntypedFormControl(billingFirma, [Validators.required, Validators.maxLength(440)]),
            street: new UntypedFormControl(billingStreet, [Validators.required, Validators.maxLength(480)]),
            plz: new UntypedFormControl(billingPlz, Validators.required),
            town: new UntypedFormControl(billingTown, [Validators.required, Validators.maxLength(250)]),
            country: new UntypedFormControl(billingCountry, Validators.required)
        });

        let beneficiaryName;
        let beneficiaryFirma;
        let beneficiaryStreet;
        let beneficiaryPlz;
        let beneficiaryTown;
        let beneficiaryCountry;

        if (this.data.property.beneficiaryAddress) {
            beneficiaryName = this.data.property.beneficiaryAddress.name ? this.data.property.beneficiaryAddress.name : '';
            beneficiaryFirma = this.data.property.beneficiaryAddress.firma ? this.data.property.beneficiaryAddress.firma : '';
            beneficiaryStreet = this.data.property.beneficiaryAddress.street ? this.data.property.beneficiaryAddress.street : '';
            beneficiaryPlz = this.data.property.beneficiaryAddress.plz ? this.data.property.beneficiaryAddress.plz : '';
            beneficiaryTown = this.data.property.beneficiaryAddress.town ? this.data.property.beneficiaryAddress.town : '';
            beneficiaryCountry = this.data.property.beneficiaryAddress.country ? this.data.property.beneficiaryAddress.country : '';
        }


        this.beneficiaryForm = this.formBuilder.group({
            name: new UntypedFormControl(beneficiaryName, Validators.maxLength(440)),
            firma: new UntypedFormControl(beneficiaryFirma, [Validators.required, Validators.maxLength(440)]),
            street: new UntypedFormControl(beneficiaryStreet, [Validators.required, Validators.maxLength(250)]),
            plz: new UntypedFormControl(beneficiaryPlz, Validators.required),
            town: new UntypedFormControl(beneficiaryTown, [Validators.required, Validators.maxLength(250)]),
            country: new UntypedFormControl(beneficiaryCountry, Validators.required)
        });

        this.showBeneficiary = !this.billingAdressEqualsBeneficiaryAdress(this.data.property);
        this.markInvalidInputs(this.billingForm);
        this.markInvalidInputs(this.beneficiaryForm);
    }

  updateDialog() {
    this.showBeneficiary = !this.showBeneficiary;
    if(this.showBeneficiary) {
      this.beneficiaryForm.reset();
    }
  }

  closeBillingForm() {
    this.dialogRef.close();
  }

  submitBillingForm() {
    this.updateShowBeneficiary(this.data.property);
    if (this.showBeneficiary) {
      if (this.billingForm.valid && this.beneficiaryForm.valid) {
        const billingAddress: BillingAdress = this.billingForm.value;
        const beneficiaryAddress: BillingAdress = this.beneficiaryForm.value;
        this.dialogRef.close({billingAddress: billingAddress, beneficiaryAddress: beneficiaryAddress});
      } else {
        this.markInvalidInputs(this.billingForm);
        this.markInvalidInputs(this.beneficiaryForm);
      }
    } else {
      if (this.billingForm.valid) {
        const billingAddress: BillingAdress = this.billingForm.value;
        this.dialogRef.close({billingAddress: billingAddress, beneficiaryAddress: billingAddress});
      } else {
        this.markInvalidInputs(this.billingForm);
      }
    }
  }

  hasError(control: AbstractControl): boolean {
    return (control.invalid && (control.touched || this.clickedButton));
  }

  updateShowBeneficiary(property){
    return !this.billingAdressEqualsBeneficiaryAdress(property);
  }

  billingAdressEqualsBeneficiaryAdress(property) {
    const { billingAdress, beneficiaryAddress } = property;
    return (
            billingAdress && beneficiaryAddress &&
        billingAdress.firma === beneficiaryAddress.firma &&
        billingAdress.street === beneficiaryAddress.street &&
        billingAdress.plz === beneficiaryAddress.plz &&
        billingAdress.town === beneficiaryAddress.town
    );
  }

  markInvalidInputs(form: UntypedFormGroup){
    Object.keys(form.controls).forEach(key => {
      if(form.get(key) instanceof UntypedFormControl){
        form.get(key).markAsTouched()
      }
      if(form.get(key) instanceof UntypedFormArray){
        form.get(key).markAllAsTouched()
      }
    })
  }
}
